<template>
  <v-container>
    <v-row class="justify-center">
      <v-btn class="mt-5" color="#6b4da9" @click="checkConnection">{{ t("button.connectionCheck") }}</v-btn>
    </v-row>
    <v-row>
      <v-progress-linear v-if="isLoading" class="mt-5" color="#6b4da9" indeterminate rounded height="6"></v-progress-linear>
    </v-row>
    <v-row class="justify-center mt-10" v-if="connectionModel.isConnectionSuccessful">
      <v-col cols="2" class="text-right">
        <v-icon color="success" size="large">
          mdi-check-circle-outline
        </v-icon>
      </v-col>
      <v-col cols="8">

        {{ t("message.success.connectionCheck") }}
      </v-col>
    </v-row>
    <v-row class="justify-center mt-10" v-if="connectionModel.isConnectionError">
      <v-col cols="3" class="text-right">
        <v-icon color="error" size="large">
          mdi-alert-circle-outline
        </v-icon>
      </v-col>
      <v-col cols="9">

        {{ t("message.error.connectionCheck") }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import VerbindungsparameterApi from "@/apis/connectionparameter-api.js";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  connectionCheckObject: {
    type: Object,
    default: {
      isConnectionSuccessful: false,
      isConnectionError: false,
    },
  },
  verbindungsparameter: {
    type: Object,
    default: {
      id: "",
      bereichId: 1,
      bezeichnung: "",
      url: "",
      benutzer: "",
      passwort: "",
      apikey: "",
      terminalsystemId: "",
    },
  },
});

const connectionModel = ref(props.connectionCheckObject);
const verbindungsparameterModel = ref(props.verbindungsparameter)
const isLoading = ref(false);

const checkConnection = async () => {
  isLoading.value = true;
  connectionModel.value.isConnectionSuccessful = false;
  const cpm = { ...verbindungsparameterModel.value };

  if (cpm.sectionId === 6) {
    const dormaString = createDormaString(cpm);
    cpm.url = dormaString
  }

  let response = await VerbindungsparameterApi.UseConnectionCheck(cpm);
  isLoading.value = false;

  if (response.status == 200) {
    const msgResult = response.data;
    console.log(msgResult);
    connectionModel.value.isConnectionSuccessful = !!msgResult.success;
    connectionModel.value.isConnectionError = !msgResult.success;
  } else {
    connectionModel.value.isConnectionSuccessful = false;
    connectionModel.value.isConnectionError = true;
  }

};

const createDormaString = (cpm) => {
  return `user id=${cpm.user};host=${cpm.url};port=${cpm.port};virtual host=${cpm.virtualhost};uuid=${cpm.uuid}`;
};
</script>